import { Fragment, useState, useEffect, useContext } from "react";
import classes from './Home.module.css';
import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar";
import Example from "./DashboardTable"
import dayjs from 'dayjs';
import { getToken, getMSID, getEmail, getName, tokenConfig } from "../../authfile";
import { UserContext } from "../../hooks/UserContext";
import { useGetWorkbenchData, useGetWorkbenchDataForWorkbench } from '../../queries/useGetWorkbenchData';
import { Link, NavLink, useLocation, useParams } from 'react-router-dom';
import useLoader from '../../hooks/useLoader';
import { ContentLayout } from "../UI/Template/ContentLayout";
import { Leftpart } from "../UI/Template/Leftpart";
import { RightPart } from "../UI/Template/Rightpart";
import { enqueueSnackbar } from "notistack";




const Home = () => {

  //  const userRole = useContext(UserContext);
  const tokenConfig = {
    headers: {
        "Authorization": `Bearer ${getToken()}`,
    },
  };
  const { report } = useLocation().state || {
    report: "DUAL ACCOUNT REPORT"
 }
 const { userRole } = useContext(UserContext);
 const [loader, showLoader, hideLoader] = useLoader();
 const [startDate, setStartDate] = useState(dayjs().subtract(90, 'day'));
 const [endDate, setEndDate] = useState(dayjs(new Date()));
 const formattedDateStart = startDate ? formatDate(startDate) : '';
 const formattedDateEnd = startDate ? formatDate(endDate) : '';

  const details = {
    name: getName(),
    email: getEmail(),
    msid: getMSID(),
    role: userRole,
    report: report
  }
  const {
    data,
    isError: isLoadingTechUsersError,
    error: loadingTechUsersError,
    isFetching: isFetchingUsersTech,
    isLoading: isLoadingUsersTech,
    refetch: refetchDataTech
  } = useGetWorkbenchData({body: {
    ...details,
    fromDate: formattedDateStart,
    toDate: formattedDateEnd
  }, config: tokenConfig});

  if(isLoadingTechUsersError){
    enqueueSnackbar(loadingTechUsersError.message,{
      variant: 'error'
    })
  }

  function formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return String([month, day, year].join('-'));
  }

  console.log("This is home");

  return (
   
      <ContentLayout>
        <Leftpart>
          <Sidebar technicianCountData={data?.TechnicianCountData} isLoading={isFetchingUsersTech || isLoadingUsersTech} />
        </Leftpart>
        <RightPart>
          <Example />
        </RightPart>
      </ContentLayout>
    
  )
}

export default Home;